document.addEventListener("click", (e) => {
  const q = e.target.closest("[data-faq-q]");
  if (!q) return;

  const item = q.closest(".thw__faqItem");
  const a = item.querySelector(".thw__faqA");

  const open = a.style.display === "block";
  a.style.display = open ? "none" : "block";
});
